import {
  ApplicationRef,
  ComponentRef,
  DOCUMENT,
  inject,
  Injectable,
  NgZone,
  ViewContainerRef
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { LocalStorageService } from '../infrastructure/storage/local-storage.service';
import { INFRASTRUCTURE_CONFIG } from '../infrastructure/infrastructure-config.token';
import { AdBlockInfoComponent } from '../components/legacy/ad-block-info/ad-block-info.component';
import { Toast } from '../components/legacy/toast/model/toast.model';

@Injectable({
  providedIn: 'root'
})
export class AdblockDetectorService {
  private applicationRef = inject(ApplicationRef);
  private localStorageService = inject(LocalStorageService);
  private translateService = inject(TranslateService);
  private ngZone = inject(NgZone);
  private doc = inject(DOCUMENT);
  private config = inject(INFRASTRUCTURE_CONFIG);

  private _blockingAds: boolean;
  private toastContainer: ComponentRef<AdBlockInfoComponent>;
  private viewContainerRef: ViewContainerRef;
  private toastIndex = 0;

  constructor() {
    this.init();
  }

  public init() {
    this._blockingAds = false;
  }

  public get blockingAds() {
    return this._blockingAds;
  }

  public checkForAdsJs(viewContainerRef: ViewContainerRef) {
    const alreadyShowed = this.localStorageService.getItem(
      this.config.storageKeys.adBlockerInfo
    );
    if (this.doc.getElementById('SW1tb21pb0FkRGV0ZWN0b3I=')) {
      this._blockingAds = false;
    } else if (!alreadyShowed) {
      this.viewContainerRef = viewContainerRef;
      this._blockingAds = true;
      this.localStorageService.setItem(
        this.config.storageKeys.adBlockerInfo,
        true
      );

      this.toastContainer =
        this.viewContainerRef.createComponent(AdBlockInfoComponent);
      const toast = new Toast(
        'info',
        this.translateService.instant('general.ad_block_detected'),
        {
          duration: 10000
        }
      );

      this.toastContainer.instance.onEmpty = () => this.destroyToastContainer();
      this.toastContainer.instance.onToastClick = (t: Toast) =>
        this.onToastClick(t);

      this.viewContainerRef.insert(this.toastContainer.hostView);

      return this.addToast(toast);
    }
  }

  private addToast(toast: Toast) {
    let timeoutId;
    toast.id = ++this.toastIndex;

    this.ngZone.runOutsideAngular(
      () =>
        (timeoutId = setTimeout(
          () => this.ngZone.run(() => this.clearToast(toast)),
          toast.duration
        ))
    );

    toast.timeoutId = timeoutId;
    this.toastContainer.instance.addToast(toast);

    return toast;
  }

  private clearToast(toast: Toast) {
    if (this.toastContainer) {
      clearTimeout(toast.timeoutId);
      this.toastContainer.instance.removeToast(toast);
    }
  }

  private destroyToastContainer() {
    if (this.toastContainer) {
      this.toastContainer.destroy();
      this.toastContainer = null;
    }
  }

  private onToastClick(toast: Toast) {
    if (toast.dismissOnClick) {
      this.clearToast(toast);
    }
  }
}
